// extracted by mini-css-extract-plugin
export default {"linkParserP":"LinkParser_linkParserP__90spr","linkParserLink":"LinkParser_linkParserLink__PApGV","linkParserA":"LinkParser_linkParserA__qkR1S"};